import { Dispatch, SetStateAction } from 'react';
import { IAcelerador } from '../../Interfaces/IAceleradores';

// export const textoTituloResultado = (mes: number) => {
//   switch (mes) {
//     case 1:
//       return 'Tus primeras 4 semanas';
//     case 4:
//       return 'Tus primeras 4 semanas';
//     case 7:
//       return 'Tus primeras 4 semanas';
//     case 10:
//       return 'Tus primeras 4 semanas';
//     default:
//       return 'Tus siguientes 4 semanas';
//   }
// };

export function ContinuarVideo(
  currentPosition: number,
  aceleradores: IAcelerador[],
  setCurrentPosition: Dispatch<SetStateAction<number>>,
) {
  if (currentPosition + 1 !== aceleradores.length) {
    if (aceleradores[currentPosition + 1]) {
      setCurrentPosition((c) => c + 1);
    }
  }
}

export function RetrocederVideo(
  currentPosition: number,
  aceleradores: IAcelerador[],
  setCurrentPosition: Dispatch<SetStateAction<number>>,
) {
  if (currentPosition !== 0) {
    if (aceleradores[currentPosition - 1]) {
      setCurrentPosition((c) => c - 1);
    }
  }
}
